export const REF_NAME = 'dev';
export const COMMIT_SHA = '034b241';
export const PIPELINE_ID = '26156';
export const BUILD_DATE = 'Tue Jan 26 13:58:08 UTC 2021';
